import * as ip from "../utils/ip";

module.exports = class ipv4Address {
    getState() {
        return ip.getV4Data();
    }
};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv4Address.js